import cx from 'classnames';
import { useRef } from 'react';

import { useDragScroll } from '@flipster/react/misc/browser/drag-scroll';

import PendingPositionTable from './PendingPositionTable';
import PurchasedPositionTable from './PurchasedPositionTable';
import styles from './positionTable.module.scss';

interface Props {
  type: 'purchased' | 'pending';
  className?: string;
  showAllSymbol: boolean;
}

export const PositionTable = ({ type, className, showAllSymbol }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const mouseEvents = useDragScroll(scrollRef);

  return (
    <div ref={scrollRef} className={cx(styles.wrapper, className)} {...mouseEvents}>
      {type === 'purchased' && <PurchasedPositionTable showAllSymbol={showAllSymbol} />}
      {type === 'pending' && <PendingPositionTable showAllSymbol={showAllSymbol} />}
    </div>
  );
};
